import { render, staticRenderFns } from "./TaskInfoWrapper.vue?vue&type=template&id=017b4582&scoped=true"
import script from "./TaskInfoWrapper.vue?vue&type=script&lang=ts"
export * from "./TaskInfoWrapper.vue?vue&type=script&lang=ts"
import style0 from "./TaskInfoWrapper.vue?vue&type=style&index=0&id=017b4582&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017b4582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('017b4582')) {
      api.createRecord('017b4582', component.options)
    } else {
      api.reload('017b4582', component.options)
    }
    module.hot.accept("./TaskInfoWrapper.vue?vue&type=template&id=017b4582&scoped=true", function () {
      api.rerender('017b4582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tasks/TaskInfoWrapper.vue"
export default component.exports